import { render } from "./SellConfig.vue?vue&type=template&id=f018adee&scoped=true"
import script from "./SellConfig.vue?vue&type=script&lang=js"
export * from "./SellConfig.vue?vue&type=script&lang=js"

import "./SellConfig.vue?vue&type=style&index=0&id=f018adee&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f018adee"]])

export default __exports__